import type { TabViewProps, TabViewRef } from '@myosh/odin-components';
import { TabView } from '@myosh/odin-components';
import clsx from 'clsx';
import type { Ref } from 'react';
import { forwardRef } from 'react';

type DashboardTabViewType = TabViewProps & {
  isEditing?: boolean;
};

const DashboardTabView = (props: DashboardTabViewType, ref?: Ref<TabViewRef>) => {
  const { children, id, onTabChange, hideBorder = false, className, activeIndex = 0 } = props;

  const headerStyles = 'tabElement';

  return children ? (
    <TabView
      className={clsx('dashboard-tab-view', className)}
      activeIndex={activeIndex}
      onTabChange={(index) => onTabChange?.(index)}
      id={id}
      ref={ref}
      headerClassName={headerStyles}
      hideBorder={hideBorder}
      scrollToNextTab
    >
      {children}
    </TabView>
  ) : null;
};

export default forwardRef(DashboardTabView);
